import { render } from "./MotivoRechazoForm.vue?vue&type=template&id=27b2608a&scoped=true"
import script from "./MotivoRechazoForm.vue?vue&type=script&lang=js"
export * from "./MotivoRechazoForm.vue?vue&type=script&lang=js"

import "./MotivoRechazoForm.vue?vue&type=style&index=0&id=27b2608a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b2608a"]])

export default __exports__